module.exports = __webpack_public_path__ + "static/img/ico-arrow.015d2f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-arrow.svg
// module id = RmhP
// module chunks = 1